import PropTypes from 'prop-types';
import React from 'react';
import Fab from '@material-ui/core/Fab';
import MyLocationIcon from '@material-ui/icons/MyLocation.js';

// TODO (stu.zhao): Base is needed because the Control element is rendered
// outside the React component tree. Probably need a better way to do this?
import OndemandBase from 'ondemand/components/OndemandBase';

const UserLocationControl = ({onClick}) => (
  <OndemandBase>
    <Fab
      color="primary"
      onClick={onClick}
    >
      <MyLocationIcon />
    </Fab>
  </OndemandBase>
);

UserLocationControl.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default UserLocationControl;



// WEBPACK FOOTER //
// ./src/ondemand/components/UserLocationControl.js